import { useTitle } from "#/utils/useTitle"

export default function Layout({ children }: { children?: React.ReactNode }) {
  useTitle('AI当日朋友推荐')
  return <div className="h-full w-full">{children}</div>
}
